import React, { useEffect, useState } from "react";
import Layout from "../../components/layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { formatDate } from "../../helpers/DateConversion";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

export default function ViewSubCategory() {
    const location = useLocation();
    const data = location.state.data;

    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [subCatg, setSubCatg] = useState([]);

    const getSubCategories = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("sansadToken");
            const headers = {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            };

            const response = await axios.get(
                `${process.env.REACT_APP_API_BASE_URL}/subCategory/by-categoryId/${data.categoryId}`,
                {
                    headers: headers,
                }
            );
            if (response.data.statusCode === 200) {
                setSubCatg(response.data.result.subCategories);
            } else {
            }
        } catch (error) {
            console.log(error);
        }
        setLoading(false);
    };

    useEffect(() => {
        getSubCategories();
    }, []);


    const deleteSubCategory = async (id) => {
        try {
            const headers = {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
            };
            const formdata = new FormData();
            formdata.append("subCategoryId", id);

            const response = await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}/subCategory/delete-subCategory`,
                formdata,
                { headers }
            );
            if (response.data.statusCode === 200) {
                toast.success(response?.data?.message);
                getSubCategories();
            } else {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to edit sub category. Please try again.", error);
        }
    };

    return (
        <div>
            <Layout>
                <ToastContainer />
                <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
                    <div className="flex justify-between items-center">
                        <h2 className="text-xl font-medium">View Meal Type</h2>

                        <button
                            onClick={() => navigate(-1)}
                            className="px-4 py-2 bg-gray-200 rounded-md hover:bg-gray-300"
                        >
                            Back
                        </button>

                    </div>

                    <div className="mt-10">
                        <div className="flex my-6">
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium"> Name</h6>
                                <p className="mt-1">{data?.title}</p>
                            </div>
                        </div>
                        <hr />

                        <hr />
                        <div className="flex my-6">
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Created At</h6>
                                <p className="mt-1">{formatDate(data.createdAt)}</p>
                            </div>
                            <div className="w-1/2">
                                <h6 className="text-sm font-medium">Status</h6>
                                <p className="mt-1">{data.status}</p>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="mx-3">
                    <div className="flex justify-between items-center mt-20 ">
                        <h2 className="text-lg font-medium">View Sub Categories</h2>
                        <div className="">
                            <button
                                className="border py-2 px-2 rounded-md text-sm !outline-none"
                                onClick={() => {
                                    navigate(`/admin-panel/sub-category/add/${data?.categoryId}`);
                                }}
                            >
                                Add Sub Category
                            </button>
                        </div>
                    </div>

                    <div className="mt-6">
                        <div className="flex gap-4 justify-between flex-wrap mt-10">
                            <table className="w-full text-center">
                                <thead>
                                    <tr className="border-b">
                                        <td className="font-medium py-4 cursor-pointer">
                                            Product Name{" "}
                                        </td>
                                        <td className="font-medium py-4 cursor-pointer">
                                            Created At{" "}
                                        </td>
                                        <td className="font-medium py-4 cursor-pointer">
                                            Status{" "}
                                        </td>
                                        <td className="font-medium py-4 cursor-pointer">
                                            Actions{" "}
                                        </td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {!loading ? (
                                        subCatg?.length > 0 ? (
                                            subCatg?.map((item) => (
                                                <tr key={item._id} className="border-b">
                                                    <td className="py-3 text-sm">{item.name}</td>
                                                    <td className="py-3 text-sm">
                                                        {formatDate(item.createdAt)}
                                                    </td>
                                                    <td className="py-3 text-sm">{item.status}</td>
                                                    <td className="py-3 text-sm flex justify-center gap-x-3">
                                                        <button
                                                            className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                                                            title="View Sub Category"
                                                            onClick={() => {
                                                                navigate(
                                                                    `/admin-panel/sub-category/view/${item._id}`,
                                                                    { state: { data: item } }
                                                                );
                                                            }}
                                                        >
                                                            <i className="fa fa-eye text-white"></i>
                                                        </button>
                                                        <button
                                                            className="h-[36px] w-[36px] bg-[#ff8a00] rounded-full"
                                                            title="Edit Sub Category"
                                                            onClick={() => {
                                                                navigate(
                                                                    `/admin-panel/sub-category/edit/${item._id}`,
                                                                    { state: { data: item } }
                                                                );
                                                            }}
                                                        >
                                                            <i className="fa fa-edit text-white"></i>
                                                        </button>
                                                        <button
                                                            className="h-[36px] w-[36px] bg-danger rounded-full"
                                                            title="Delete Sub Category"
                                                            onClick={() => {
                                                                deleteSubCategory(item?._id);
                                                            }}
                                                        >
                                                            <i className="fa fa-trash text-white"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <td colSpan={4} className="text-center">
                                                <p className="text-center w-full mt-10">
                                                    No results found
                                                </p>
                                            </td>
                                        )
                                    ) : (
                                        <td colSpan={4} className="text-center">
                                            <p className="text-center w-full mt-10">
                                                Loading ...
                                            </p>
                                        </td>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

            </Layout>
        </div>
    );
}
